import { render, staticRenderFns } from "./DoctorData.vue?vue&type=template&id=53e2a874&scoped=true&"
import script from "./DoctorData.vue?vue&type=script&lang=js&"
export * from "./DoctorData.vue?vue&type=script&lang=js&"
import style0 from "./DoctorData.vue?vue&type=style&index=0&id=53e2a874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e2a874",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VChip,VCol,VRow,VSelect})
